import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import { MuiSelectAutoComplete, MuiTextField, MuiButton } from '../../../../../components'
import keywordManagement from '../../../../../services/keywordManagement.service'
import { useGlobalStore } from '../../../../../store'
import { consoleLog, getObjectAsArray } from '../../../../../util'
import { OuterWrapper, Error, Message } from './style'

const Add = ({ onChange }) => {
  const { company } = useGlobalStore()
  const strAddNew = 'Add New...'
  const initialFormObj = {
    keywordSelect: strAddNew,
    notesSelect: strAddNew,
    typeSelect: strAddNew,
    subTypeSelect: strAddNew,
    keywordInput: '',
    notesInput: '',
    typeInput: '',
    subTypeInput: ''
  }

  const form = useRef()
  // const [formSectionData, setFormSectionData] = useState(defaultDataFunc())
  const [formData, setFormData] = useState(initialFormObj)
  const [formError, setFormError] = useState('')
  const [formSuccess, setFormSuccess] = useState('')
  const [formSelectData, setFormSelectData] = useState({
    keyword: [],
    notes: [],
    type: [],
    subType: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    if (key === 'keywordSelect') {
      obj.keywordInput = null
    } else if (key === 'notesSelect') {
      obj.notesInput = null
    } else if (key === 'typeSelect') {
      obj.typeInput = null
    } else if (key === 'subTypeSelect') {
      obj.subTypeInput = null
    }

    if (key === 'keywordSelect' && formData?.keywordSelect === strAddNew) {
      obj.notesInput = obj.typeInput = obj.subTypeInput = ' '
    } else if (key === 'notesSelect' && formData?.notesSelect === strAddNew) {
      obj.typeInput = obj.subTypeInput = ' '
    } else if (key === 'typeSelect' && formData?.typeSelect === strAddNew) {
      obj.subTypeInput = ' '
    }
    consoleLog('obj ------- ', obj)
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = {
      keywordSelect: formData?.keywordSelect || null,
      notesSelect: formData?.notesSelect || null,
      typeSelect: formData?.typeSelect || null,
      subTypeSelect: formData?.subTypeSelect || null,
      keywordInput: formData?.keywordInput || null,
      notesInput: formData?.notesInput || null,
      typeInput: formData?.typeInput || null,
      subTypeInput: formData?.subTypeInput || null
    }
    const finalObject = {
      apiType: '',
      payload: {}
    }

    // INPUT VALIDATION
    const validateSelectInputFunc = (key, selectKey, inputKey) => {
      if (obj[selectKey] === strAddNew && (obj[inputKey] === null || obj[inputKey] === '')) {
        setFormError(`Please provide the ${key} value to process your request.`)
        return true
      } else if (obj[selectKey] === null && key === 'keyword') {
        setFormError(`Please select the ${key} dropbox to process your request.`)
        return true
      }

      if (obj[selectKey] !== null) {
        finalObject.apiType += `${key}_`
        finalObject.payload = { ...finalObject.payload, [key]: (obj[inputKey]) !== null ? obj[inputKey] : obj[selectKey] }
      }
      setFormError('')
      return false
    }

    if (validateSelectInputFunc('keyword', 'keywordSelect', 'keywordInput')) { return false }
    if (validateSelectInputFunc('notes', 'notesSelect', 'notesInput')) { return false }
    if (validateSelectInputFunc('type', 'typeSelect', 'typeInput')) { return false }
    if (validateSelectInputFunc('subType', 'subTypeSelect', 'subTypeInput')) { return false }

    const isInputObject = {
      keyword: (obj.keywordSelect === strAddNew),
      notes: (obj.notesSelect === strAddNew),
      type: (obj.typeSelect === strAddNew),
      subType: (obj.subTypeSelect === strAddNew)
    }

    finalObject.keyword = isInputObject.keyword ? obj.keywordInput : obj.keywordSelect
    finalObject.notes = isInputObject.notes ? obj.notesInput : obj.notesSelect
    finalObject.type = isInputObject.type ? obj.typeInput : obj.typeSelect
    finalObject.subType = isInputObject.subType ? obj.subTypeInput : obj.subTypeSelect

    const payload_keyword = { organizationId: company?.OrganizationId, keywordValue: finalObject.keyword, delete: false }
    const payload_notes = { organizationId: company?.OrganizationId, keywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
    const payload_type = { organizationId: company?.OrganizationId, keywordTypeValue: finalObject.type, parentKeywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
    const payload_subType = { organizationId: company?.OrganizationId, keywordSubTypeValue: finalObject.subType, parentKeywordTypeValue: finalObject.type, parentKeywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }

    if (formData?.subTypeSelect !== strAddNew || (formData?.subTypeInput?.replaceAll(' ', ''))?.length > 0) {
      if (finalObject.keyword.length > 1 && finalObject.notes.length > 1 && finalObject.type.length > 1) {
        await keywordManagement.setOrganizationAggregationNonSearchKeywordApi(payload_keyword)
        await keywordManagement.setOrganizationAggregationKeywordNotesApi(payload_notes)
        await keywordManagement.setOrganizationAggregationKeywordTypeApi(payload_type)
        await keywordManagement.setOrganizationAggregationKeywordSubTypeApi(payload_subType)
      } else {
        setFormError('Kindly fill all the fields !!')
      }
    } else if (formData?.typeSelect !== strAddNew || (formData?.typeInput?.replaceAll(' ', ''))?.length > 0) {
      if (finalObject.keyword.length > 1 && finalObject.notes.length > 1) {
        await keywordManagement.setOrganizationAggregationNonSearchKeywordApi(payload_keyword)
        await keywordManagement.setOrganizationAggregationKeywordNotesApi(payload_notes)
        await keywordManagement.setOrganizationAggregationKeywordTypeApi(payload_type)
      } else {
        setFormError('Kindly fill all the fields !!')
      }
    } else if (formData?.notesSelect !== strAddNew || (formData?.notesInput?.replaceAll(' ', ''))?.length > 0) {
      if (finalObject.keyword.length > 1) {
        await keywordManagement.setOrganizationAggregationNonSearchKeywordApi(payload_keyword)
        await keywordManagement.setOrganizationAggregationKeywordNotesApi(payload_notes)
      } else {
        setFormError('Kindly fill all the fields !!')
      }
    } else if (formData?.keywordSelect !== strAddNew || (formData?.keywordInput?.replaceAll(' ', ''))?.length > 0) {
      await keywordManagement.setOrganizationAggregationNonSearchKeywordApi(payload_keyword)
    }

    /*
    if (isInputObject.keyword) {
      const payload = { organizationId: company?.OrganizationId, keywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationNonSearchKeywordApi(payload)
    }
    if (isInputObject.notes) {
      const payload = { organizationId: company?.OrganizationId, keywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationKeywordNotesApi(payload)
    }
    if (isInputObject.type) {
      const payload = { organizationId: company?.OrganizationId, keywordTypeValue: finalObject.type, parentKeywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationKeywordTypeApi(payload)
    }
    if (isInputObject.subType) {
      const payload = { organizationId: company?.OrganizationId, keywordSubTypeValue: finalObject.subType, parentKeywordTypeValue: finalObject.type, parentKeywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationKeywordSubTypeApi(payload)
    }

    // //////////////////////////////////

    if (finalObject.apiType === 'keyword_' && !isInputObject.keyword) {
      const payload = { organizationId: company?.OrganizationId, keywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationNonSearchKeywordApi(payload)
    } else if (finalObject.apiType === 'keyword_notes_' && !isInputObject.notes) {
      const payload = { organizationId: company?.OrganizationId, keywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationKeywordNotesApi(payload)
    } else if (finalObject.apiType === 'keyword_notes_type_' && !isInputObject.type) {
      const payload = { organizationId: company?.OrganizationId, keywordTypeValue: finalObject.type, parentKeywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationKeywordTypeApi(payload)
    } else if (finalObject.apiType === 'keyword_notes_type_subType_' && !isInputObject.subType) {
      const payload = { organizationId: company?.OrganizationId, keywordSubTypeValue: finalObject.subType, parentKeywordTypeValue: finalObject.type, parentKeywordNotesValue: finalObject.notes, parentKeywordValue: finalObject.keyword, delete: false }
      await keywordManagement.setOrganizationAggregationKeywordSubTypeApi(payload)
    }
    */

    setFormSuccess('Data added successfully')

    setTimeout(() => {
      onChange(obj)
      resetForm()
    }, 2000)
  }

  const onload = async () => {
    try {
      const payload = { organizationId: company?.OrganizationId }
      const keywordApi = await keywordManagement.getOrganizationAggregationKeywordsApi(payload)

      const keywordArray = getObjectAsArray(keywordApi, 'adv').map(d => ({ label: d.KeywordValue, value: d.KeywordValue, valKeywordValue: d.KeywordValue, valKeywordId: d.KeywordId, valKeywordSearchTerm: d.KeywordSearchTerm }))
      // keywordArray.unshift({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
      keywordArray.unshift({ label: strAddNew, value: strAddNew, valKeywordValue: strAddNew, valKeywordId: strAddNew, valKeywordSearchTerm: strAddNew })

      const notesApi = await keywordManagement.getOrganizationAggregationKeywordNotesApi(payload)
      const notesArray = getObjectAsArray(notesApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: newVal, value: newVal }]), [])
      notesArray.unshift({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
      notesArray.unshift({ label: strAddNew, value: strAddNew, valKeywordValue: strAddNew, valKeywordId: strAddNew, valKeywordSearchTerm: strAddNew })

      const typeApi = await keywordManagement.getOrganizationAggregationKeywordTypesApi(payload)
      const typeArray = getObjectAsArray(typeApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: newVal, value: newVal }]), [])
      typeArray.unshift({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
      typeArray.unshift({ label: strAddNew, value: strAddNew, valKeywordValue: strAddNew, valKeywordId: strAddNew, valKeywordSearchTerm: strAddNew })

      const subTypeApi = await keywordManagement.getOrganizationAggregationKeywordSubTypesApi(payload)
      const subTypeArray = getObjectAsArray(subTypeApi, 'adv').reduce((oldVal, newVal) => ([...oldVal, { label: newVal, value: newVal }]), [])
      subTypeArray.unshift({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })
      subTypeArray.unshift({ label: strAddNew, value: strAddNew, valKeywordValue: strAddNew, valKeywordId: strAddNew, valKeywordSearchTerm: strAddNew })

      setFormSelectData(prev => ({ ...prev, keyword: keywordArray, notes: notesArray, type: typeArray, subType: subTypeArray }))
    } catch (error) {
      consoleLog('error = ', error)
    }
  }

  const resetForm = () => {
    setFormData(initialFormObj)
    // setFormError('')
    // setFormSuccess('')
    onload()
  }

  useEffect(() => {
    if (company?.OrganizationId) onload()
  }, [company?.OrganizationId])

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload} autoComplete='on'>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <MuiSelectAutoComplete
              data={formSelectData.keyword}
              name='keyword'
              placeholder='Keyword'
              label='Keywords'
              onChange={(e) => onChangeHandler('keywordSelect', e.target.value)}
              variant='standard'
              value={formData.keywordSelect}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiSelectAutoComplete
              data={formSelectData.notes}
              name='notes'
              placeholder='Notes'
              label='Notes'
              onChange={(e) => onChangeHandler('notesSelect', e.target.value)}
              variant='standard'
              value={formData?.notesSelect || ''}
              // disabled={idDisabledFunc('select', 'notes')}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiSelectAutoComplete
              data={formSelectData.type}
              name='type'
              placeholder='Type'
              label='Type'
              onChange={(e) => onChangeHandler('typeSelect', e.target.value)}
              variant='standard'
              value={formData?.typeSelect || ''}
              // disabled={idDisabledFunc('select', 'type', formData.typeSelect)}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiSelectAutoComplete
              data={formSelectData.subType}
              name='subType'
              placeholder='Sub Type'
              label='Sub Type'
              onChange={(e) => onChangeHandler('subTypeSelect', e.target.value)}
              variant='standard'
              value={formData?.subTypeSelect || ''}
              // disabled={idDisabledFunc('select', 'subType', formData.subTypeSelect)}
            />
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='keyword'
              placeholder='Enter Keyword'
              onChange={(e) => onChangeHandler('keywordInput', e.target.value)}
              variant='standard'
              value={formData?.keywordInput || ''}
              disabled={formData?.keywordSelect !== strAddNew}
              // disabled={idDisabledFunc('input', 'keyword', formData.keywordInput)}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='notes'
              placeholder='Enter Note'
              onChange={(e) => onChangeHandler('notesInput', e.target.value)}
              variant='standard'
              value={formData?.notesInput || ''}
              disabled={formData?.notesSelect !== strAddNew}
              // disabled={idDisabledFunc('input', 'notes', formData.notesInput)}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='type'
              placeholder='Enter Type'
              onChange={(e) => onChangeHandler('typeInput', e.target.value)}
              variant='standard'
              value={formData?.typeInput || ''}
              disabled={formData?.typeSelect !== strAddNew}
              // disabled={idDisabledFunc('input', 'type', formData.typeInput)}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='subType'
              placeholder='Enter Sub Type'
              onChange={(e) => onChangeHandler('subTypeInput', e.target.value)}
              variant='standard'
              value={formData?.subTypeInput || ''}
              disabled={formData?.subTypeSelect !== strAddNew}
              // disabled={idDisabledFunc('input', 'subType', formData.subTypeInput)}
            />
          </Grid>
          <Grid item xs={13} style={{ justifyContent: 'space-between', display: 'flex' }}>
            <Box>
              {formError && <Error>{formError}</Error>}
              {formSuccess && <Message>{formSuccess}</Message>}
            </Box>
            <Box>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px', marginRight: '10px' }}
              >
                Add
              </MuiButton>
              <MuiButton
                onClick={() => onChange()}
                type='button'
                color='primary'
                variant='contained'
                style={{ width: '120px' }}
              >
                Refresh
              </MuiButton>
            </Box>
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
